import { StyledModal } from 'common/components';

import { Typography } from 'antd';

const { Paragraph } = Typography;
const ProfessionallyCaptureProductModal = ({ visible, setVisible }) => {
  return (
    <StyledModal
      visible={visible}
      title='Professionally Capture Product'
      onOk={() => setVisible(false)}
      cancelButtonProps={{ style: { display: 'none' } }}
      onCancel={() => setVisible(false)}
    >
      <Paragraph style={{ fontSize: '15px', display: 'block' }}>
        Following GS1 Standards, IX-ONE capture provides complete imagery and
        data that is then proactively shared across our network; removing costs,
        confusion and redundancy.
      </Paragraph>
      <Paragraph style={{ fontSize: '15px', display: 'block' }}>
        To begin the capture process, please visit our{' '}
        <a
          href='https://www.thedatacouncil.com/productloadform/'
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'underline' }}
        >
          Professional Capture Services Center
        </a>{' '}
        and follow Steps 1 and 2.
      </Paragraph>
    </StyledModal>
  );
};

export default ProfessionallyCaptureProductModal;
